import { cn } from "@/lib/utils";
import dayjs from "dayjs";
import { IconNode } from "lucide-react";
import { ReactNode } from "react";
import { icons } from "lucide-react";
import Icon from "@/components/ui/icon";

export interface TimelineItem {
  title: string;
  time: string | Date;
  subTitle: string;
  textColor: string;
  iconColor: string;
  borderColor: string;
  icon?: ReactNode;
}

interface Props {
  timeLineItems?: TimelineItem[];
  className?: string;
}

function Timeline(props: Props) {
  const { timeLineItems, className } = props;

  return (
    <div className={cn("", className)}>
      <div className="rb-container">
        <ul className="rb">
          {timeLineItems.map((item, index) => (
            // <div key={index} className="flex items-stretch relative m-2 my-5">
            //   <div className="flex items-center w-[48px] justify-center z-50">
            //     <div className="w-8 h-8 rounded-full flex items-center justify-center bg-primary/20 p-1 ring-8 ring-primary/10">
            //       <Icon
            //         name={item.icon as keyof typeof icons}
            //         size={24}
            //         color="hsl(var(--primary))"
            //         className="text-primary"
            //       />
            //     </div>
            //   </div>
            //   <div className="absolute top-0 w-2 bottom-0 left-0 right-0 bg-red-400 z-10"></div>
            //   <div className="bg-card rounded-md p-3 ml-2">
            //     <h3 className="capitalize text-sm">{item.title}</h3>
            //     <p className="text-muted-foreground text-xs">{item.subTitle}</p>
            //     <p className="mt-1 text-xs text-muted-foreground">
            //       {dayjs(String(item.time)).format("MM/DD/YYYY h:mm A")}
            //     </p>
            //   </div>
            // </div>

            <li
              key={index}
              className="rb-item border-l border-dashed border-l-primary relative before:absolute before:left-[-10px] before:top-0 before:content-[''] before:border-[8px] before:border-primary dark:before:border-white before:rounded-full dark:before:bg-primary before:bg-white before:h-[20px] before:w-[20px] before:transition-all before:duration-500 hover:before:border-primary hover:before:duration-1000 last:border-l-0"
            >
              <div className="relative text-xs text-muted-foreground">
                {dayjs(String(item.time)).format("MM/DD/YYYY h:mm A")}
              </div>
              <div className="text-sm capitalize">{item.title}</div>
              <div className="relative text-xs text-muted-foreground">
                {item.subTitle}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Timeline;
